export enum ServiceStatusEnums {
  inProgress = 'In Progress',
  memberReview = 'Member Review',
  completed = 'Completed'
}

export enum ServiceStatusesSnakeCaseEnums {
  inProgress = 'in_progress',
  memberReview = 'member_review',
  completed = 'completed',
}

export type ServiceStatusTypes = ServiceStatusEnums.inProgress | ServiceStatusEnums.memberReview | ServiceStatusEnums.completed;

export type ServiceStatusSnakeCaseTypes = ServiceStatusesSnakeCaseEnums.inProgress | ServiceStatusesSnakeCaseEnums.memberReview | ServiceStatusesSnakeCaseEnums.completed;
